"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslateMixin = void 0;
var i18n_1 = require("../directives/i18n");
exports.TranslateMixin = {
    'name': 'TranslateMixin',
    'methods': {
        $t: function (englishString) {
            return i18n_1.$t(englishString);
        },
    },
};
//# sourceMappingURL=TranslateMixin.js.map